import React from "react";
import { SVG } from "@components/items/common/SVG";

const TitledHorizontalListSkeleton = () => {
  return (
    <div className="flex items-center justify-around">
      {Array.from({ length: 9 }).map((e, i) => (
        <SVG
          key={i}
          src="/assets/icons/star.svg"
          className="h-[135px] w-[135px] animate-pulse"
          preProcessor={(code: string) =>
            code
              .replace(/(?<=fill=)"(?!none")[^"]+/g, `"${"#E6E6E6"}"`)
              .replace(/(?<=stroke=)"(?!none")[^"]+/g, `"${"#E6E6E6"}"`)
          }
        />
      ))}
    </div>
  );
};

export default TitledHorizontalListSkeleton;
